import { PARTNERS_PERIOD_FILTER_EVENTS } from './global-events';

export const partnersPeriodCalendarEventMap = {
  'range-selected': PARTNERS_PERIOD_FILTER_EVENTS.PARTNERS_PERIOD_FILTER_DATES_RANGE,
};

export const partnersPeriodFilterOptions = [
  {
    id: 'current_month',
    name: 'Поточний місяць',
    event: PARTNERS_PERIOD_FILTER_EVENTS.PARTNERS_PERIOD_FILTER_CURRENT_MONTH,
    options: {
      type: 'checkbox',
      activeFilter: false,
    },
  },
  {
    id: 'months',
    name: 'Місяць',
    event: PARTNERS_PERIOD_FILTER_EVENTS.PARTNERS_PERIOD_FILTER_MONTH,
    options: {
      type: 'checkbox',
    },
  },
  {
    id: 'weeks',
    name: 'Тиждень',
    event: PARTNERS_PERIOD_FILTER_EVENTS.PARTNERS_PERIOD_FILTER_WEEK,
    options: {
      type: 'checkbox',
    },
  },
  {
    id: 'days',
    name: 'День',
    event: PARTNERS_PERIOD_FILTER_EVENTS.PARTNERS_PERIOD_FILTER_DAY,
    options: {
      type: 'checkbox',
    },
  },
];
